@if (tour(); as t) {
<div class="tcd-backdrop" (click)="onDone()">
  <div class="tcd-card" [style.--tour-accent]="accent()" (click)="$event.stopPropagation()">
    <div class="tcd-body">
      <div class="tcd-check">
        <span class="material-icons">check</span>
      </div>
      <div class="tcd-title">Nice!</div>
      <div class="tcd-subtitle">You've completed this tour.</div>
    </div>
    <div class="tcd-actions">
      <button class="tcd-primary" (click)="onReplay()">Replay Tour</button>
      <button class="tcd-secondary" (click)="onBrowse()">Browse More Tours</button>
      <button class="tcd-secondary" (click)="onDone()">Done</button>
    </div>
  </div>
</div>
}
